import { TFunction } from "i18next";
import { EntriesTableSettings } from "../../../model/entries-table-settings/EntriesTableSettings";
import { EntriesTableMainFields } from "../../../model/entries-table-settings/types/EntriesTableMainFields.enum";
import { CreateFormDto } from "../../../model/form/dto/CreateFormDto";
import { EntryFieldsDefaults } from "../../../model/form/types/EntryFieldsDefaults.enum";
import { FormType } from "../../../model/form/types/FormType.enum";
import { InputTypes } from "../../../model/form/types/InputTypes.enum";
import { GetUserCurrentThresholdsResponseDto } from "../../../model/threshold/dto/GetUserCurrentThresholdsResponseDto";
import { Form } from "../../../model/form/Form";
import { CreateFormInputDto } from "../../../model/form/dto/CreateFormInputDto";

export const FORMS_CREATE_PARAM = "create";

export function canCreateForm(
  thresholds: GetUserCurrentThresholdsResponseDto | null,
): boolean {
  if (
    !thresholds ||
    thresholds?.total?.FORMS! - thresholds?.consumed?.FORMS! <= 0
  ) {
    return false;
  }

  return true;
}

function fieldToType(field: string) {
  switch (field) {
    case "email":
      return InputTypes.EMAIL;
    case "phone":
      return InputTypes.PHONE;
    case "message":
      return InputTypes.TEXTAREA;
    case "name":
    default:
      return InputTypes.TEXT;
  }
}

export function getFormDefaultInputs(
  entriesTableSetting: EntriesTableSettings,
): CreateFormDto["inputs"] {
  const createableColumns = entriesTableSetting?.columns?.filter((c) =>
    Object.values(EntryFieldsDefaults)
      .filter(
        (f) =>
          ![
            EntryFieldsDefaults.SOURCE,
            EntryFieldsDefaults.FORM,
            EntryFieldsDefaults.CREATED,
          ].includes(f),
      )
      .includes(c.field as EntryFieldsDefaults),
  );

  if (!createableColumns?.length) {
    return [];
  }

  return createableColumns.map((c) => ({
    type: fieldToType(c.field),
    label: c.field,
    order: c.order,
    required: false,
    custom: false,
    name: c.field,
  }));
}

export const getDefaultInputs = (
  type: FormType,
  config: {
    selectedForm: Form | null;
    tableSettings: EntriesTableSettings;
    t: TFunction;
  },
): CreateFormInputDto[] => {
  if (type === FormType.ENTRY) {
    const mainFields = config.tableSettings?.mainFields || [
      EntriesTableMainFields.EMAIL,
    ];

    return (
      config.selectedForm?.inputs ||
      getFormDefaultInputs(config.tableSettings)
        .filter(({ name }) =>
          mainFields.includes(name as EntriesTableMainFields),
        )
        .map((x) => ({
          ...x,
          label: config.t(`common.${x.label}`),
          settings: {
            ...x.settings,
            required: true,
          },
        }))
    );
  }

  if (type === FormType.MODULE) {
    return config?.selectedForm?.inputs || [];
  }

  return [];
};
